import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

import sanityClient from "../client.js";
import background from "../assets/about-bg.jpg";
import imageUrlBuilder from "@sanity/image-url";
import BlockContent from "@sanity/block-content-to-react";

const builder = imageUrlBuilder(sanityClient);
function urlFor(source) {
    return builder.image(source);
}

export default function About() {
    const [author, setAuthor] = useState(null);

    useEffect(() => {
        sanityClient
            .fetch(
                `*[_type == "author"]{
          name,
          bio,
          "authorImage": image.asset->url
      }`
            ) //"bio": bio[0].children[0].text,
            .then((data) => setAuthor(data[0]))
            .catch(console.error);
    }, []);

    if (!author) return <div>Loading...</div>;

    return (
        <main className="relative">
            <img src={background} alt="Background" className="absolute w-screen h-screen" />
            <div className="p-10 lg:pt-48 container mx-auto relative">
                <section className=" opacity-75 border-separate border-8 border-green-200 rounded-lg shadow-2xl lg:flex p-20">
                    <img
                        src={urlFor(author.authorImage).url()}
                        className="rounded w-32 h-32 lg:w-64 lg:h-64 mr-8"
                        alt={author.name}
                    />
                    <div className="text-lg flex flex-col justify-center">
                        <h1 className="cursive text-6xl text-green-200 mb-4">
                            Hey there. I'm{" "}
                            <span className="text-green-200">{author.name}</span>
                        </h1>
                        <div className="prose lg:prose-xl text-white">
                            <BlockContent blocks={author.bio} projectId="lsccpe3p" dataset="production" />
                        </div>
                        {/* <p className="text-green-200 text-lg">{author.bio}</p> */}
                        <NavLink
                            to="/chatroom"
                            className="inline-flex text-2xl items-center py-3 px-3 my-6 rounded text-green-100 hover:text-yellow-300 bg-green-700"> Chat with me...
                        </NavLink>
                    </div>
                </section>
            </div>


        </main>

    );
}